import gql from 'graphql-tag';

const WDT_CLASSROOM_PROGRESS_BY_STUDENTS_QUERY = gql`
  query wdtClassroomProgressByStudentsReport(
    $where: WdtClassroomProgressByStudentsReportWhereInput!
    $dateRange: DateRangeInput
  ) {
    wdtClassroomProgressByStudentsReport(where: $where, dateRange: $dateRange) {
      studentProgress {
        student {
          id
          firstName
          lastName
          gradeLevel
          __typename
        }
        level
        charactersCompletedCount
      }
    }
  }
`;

export default WDT_CLASSROOM_PROGRESS_BY_STUDENTS_QUERY;
